import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { t } from "@redotech/redo-i18n";
import { RouteObject } from "react-router-dom";
import { Page } from "../order/page";

export const withdrawalRoutes: RouteObject[] = [
  {
    path: ":withdrawalId",
    lazy: async () => {
      const { WithdrawalConfirmation } = await import(
        "@redotech/redo-customer-portal-app/portal-four/returns/withdrawal-confirmation-page"
      );
      return {
        element: (
          <AuthGuard
            unauthorizedMessage={t(
              "You need to login again to see this withdrawal.",
            )}
          >
            <Page>
              <WithdrawalConfirmation />
            </Page>
          </AuthGuard>
        ),
      };
    },
  },
];
